$( document ).ready(function() {
    console.log( "ready!" );
    $('[data-toggle="popover"]').popover()
    $('[data-toggle="tooltip"]').tooltip()
    //AOS.init();
});